import cn from 'classnames';
import type { MouseEventHandler } from 'react';
import { useFormContext } from 'react-hook-form';
import { AddThin } from '@shared/assets/icons';
import { useMobile } from '@shared/hooks';
import { Card, IconButton } from '@shared/ui';
import * as st from './styles.module.scss';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement>;

export const AddPromoCard: React.FC<Props> = ({ onClick, ...props }) => {
  const {
    formState: { errors },
  } = useFormContext();

  const { isMobile } = useMobile();

  return (
    <Card className={st.card} onClick={onClick as MouseEventHandler<HTMLDivElement> | undefined}>
      <div className={cn(st.card__inner, errors.promo_video && st.error)}>
        <div className={st.card__button}>
          <IconButton type="button" size={isMobile ? 'medium-large' : 'medium'} {...props}>
            <AddThin />
          </IconButton>
        </div>
      </div>
    </Card>
  );
};
